<template>
    <div
        class="switcher"
        :class="[ 'switcher_size-' + size, 'switcher_' + type, state ? 'switcher_active' : '' ]"
    >
        <span>{{ leftSign }}</span>
        <div
            class="switcher__control"
            @click="onClick"
        >
            <div class="switcher__mark" />
        </div>
        <span>{{ rightSign }}</span>
    </div>
</template>

<script>
export default {
    name: 'Switcher',

    props: {
        size: {
            type: String,
            required: false,
            default: 'default',
        },
        type: {
            type: String,
            required: false,
            default: 'default',
        },
        leftSign: {
            type: String,
            required: false,
            default: '',
        },
        rightSign: {
            type: String,
            required: false,
            default: '',
        },
        state: {
            type: Boolean,
            required: true,
        },
        handler: {
            type: Function,
            required: false,
            default: null,
        }
    },

    data: () => {
        return {}
    },

    methods: {
        onClick() {
            this.handler()
        },
    },
}
</script>

<style lang='scss' scoped>
.switcher {
  display: inline-block;
  cursor: default;
  font-size: 14px;
  line-height: 30px;
  user-select: none;

  &__control {
    background-color: #6d6d6d;
    border-radius: 15px;
    position: relative;
    height: 30px;
    width: 50px;
    display: inline-block;
    vertical-align: middle;
    margin: 0 15px;
    overflow: hidden;
    cursor: pointer;
    transition: all .2s;

    &:hover {
        .switcher__mark {
            left: 6px;
        }
    }
  }

  &__mark {
    position: absolute;
    top: 1px;
    left: 1px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background-color: #fff;
    box-shadow: 0px 2px 2px 0px rgba(0, 0, 0, 0.39);
    transition: all .2s;
  }

  &_active {
      .switcher {
          &__control {
              background: #f68c08 linear-gradient(-270deg, rgba(245, 156, 7, 1) 0%, rgba(245, 117, 7, 1) 100%);

              &:hover {
                .switcher__mark {
                  left: 16px;
                }
              }
          }

          &__mark {
              left: 21px;
          }
      }
  }


  &_size {
      &-mini {
        line-height: 20px;

        .switcher {
        
          &__control {
            height: 20px;
            width: 40px;
            margin: 0 10px;

            &:hover {
              .switcher__mark {
                left: 8px;
              }
            }
          }

          &__mark {
              width: 14px;
              height: 14px;
              top: 3px;
              left: 3px;
          }
        }

        &.switcher_active {
          .switcher {
            &__control {

              &:hover {
                .switcher__mark {
                  left: 18px;
                }
              }
            }

            &__mark {
              left: 23px;
            }
          }
        }
      }
  }
}
</style>